import {
    CREATE_MANUAL_BOOKING_START,
    CREATE_MANUAL_BOOKING_SUCCESS,
    CREATE_MANUAL_BOOKING_ERROR
} from '../../../constants';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';
import { createBooking as mutation } from '../../../lib/graphql';
import history from '../../../history';

export const createBooking = (variables) => {

    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: CREATE_MANUAL_BOOKING_START,
                payload: {
                    loading: true
                }
            });

            const { data } = await client.mutate({
                mutation,
                variables
            })

            data?.createBooking?.status == 200 && history.push('/siteadmin/manual-bookings/view/' +  data?.createBooking?.result?.id);
            data?.createBooking?.status != 200 && showToaster({ messageId: 'errorMessage', requestContent: data?.createBooking?.errorMessage, toasterType: 'error' })
            dispatch({
                type: data?.createBooking?.status == 200 ? CREATE_MANUAL_BOOKING_SUCCESS : CREATE_MANUAL_BOOKING_ERROR,
                payload: {
                    loading: false
                }
            });

        } catch (error) {
            showToaster({ messageId: 'errorMessage', requestContent: error, toasterType: 'error' })
            dispatch({
                type: CREATE_MANUAL_BOOKING_ERROR,
                payload: {
                    loading: false
                }
            });
        }
    }
}
